import { useEffect, useState } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { initializeDefaultData } from '@/services/storage';

// 前端页面
import FrontLayout from '@/layouts/FrontLayout';
import Home from '@/pages/Home';
import Products from '@/pages/Products';
import ProductDetail from '@/pages/ProductDetail';
import Applications from '@/pages/Applications';
import About from '@/pages/About';
import News from '@/pages/News';
import NewsDetail from '@/pages/NewsDetail';
import Contact from '@/pages/Contact';
import Technology from '@/pages/Technology';
import SampleApply from '@/pages/SampleApply';
import Jobs from '@/pages/Jobs';

// 后台管理
import AdminLayout from '@/layouts/AdminLayout';
import AdminLogin from '@/pages/admin/Login';
import AdminDashboard from '@/pages/admin/Dashboard';
import AdminProducts from '@/pages/admin/Products';
import AdminProductEdit from '@/pages/admin/ProductEdit';
import AdminCategories from '@/pages/admin/Categories';
import AdminParams from '@/pages/admin/Params';
import AdminInquiries from '@/pages/admin/Inquiries';
import AdminNews from '@/pages/admin/News';
import AdminHonors from '@/pages/admin/Honors';
import AdminJobs from '@/pages/admin/Jobs';
import AdminPageContent from '@/pages/admin/PageContent';
import AdminSystemConfig from '@/pages/admin/SystemConfig';
import AdminAttachments from '@/pages/admin/Attachments';
import AdminOperationLogs from '@/pages/admin/OperationLogs';
import AdminJobApplications from '@/pages/admin/JobApplications';
import AdminApplications from '@/pages/admin/Applications';

import AdminSettings from '@/pages/admin/AdminSettings';

function App() {
  const [isReady, setIsReady] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const init = async () => {
      try {
        await initializeDefaultData();
        setIsReady(true);
      } catch (err) {
        console.error('初始化失败:', err);
        setError(err?.message || String(err));
      }
    };
    init();
  }, []);

  if (error) {
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <h1>加载失败</h1>
        <p style={{ color: 'red' }}>{error}</p>
        <button onClick={() => window.location.reload()}>刷新</button>
      </div>
    );
  }

  if (!isReady) {
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <p>加载中...</p>
      </div>
    );
  }

  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<FrontLayout />}>
          <Route index element={<Home />} />
          <Route path="products" element={<Products />} />
          <Route path="products/:id" element={<ProductDetail />} />
          <Route path="applications" element={<Applications />} />
          <Route path="about" element={<About />} />
          <Route path="news" element={<News />} />
          <Route path="news/:id" element={<NewsDetail />} />
          <Route path="contact" element={<Contact />} />
          <Route path="technology" element={<Technology />} />
          <Route path="sample-apply" element={<SampleApply />} />
          <Route path="jobs" element={<Jobs />} />
        </Route>

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="products" element={<AdminProducts />} />
          <Route path="products/new" element={<AdminProductEdit />} />
          <Route path="products/edit/:id" element={<AdminProductEdit />} />
          <Route path="categories" element={<AdminCategories />} />
          <Route path="params" element={<AdminParams />} />
          <Route path="inquiries" element={<AdminInquiries />} />
          <Route path="news" element={<AdminNews />} />
          <Route path="applications" element={<AdminApplications />} />
          <Route path="honors" element={<AdminHonors />} />
          <Route path="jobs" element={<AdminJobs />} />
          <Route path="page-content" element={<AdminPageContent />} />
          <Route path="system-config" element={<AdminSystemConfig />} />
          <Route path="attachments" element={<AdminAttachments />} />
          <Route path="operation-logs" element={<AdminOperationLogs />} />
          <Route path="job-applications" element={<AdminJobApplications />} />
          <Route path="admins" element={<AdminSettings />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}

export default App;
